import { FC } from 'react';
import styled from 'styled-components';
import DownloadButton from '../atoms/DownloadButton';
import { ScreenSize, useScreenSize } from '../../contexts/ScreenSizeContext';
import cv from './jscv.pdf';

const Container = styled.div<{ $screenSize: ScreenSize }>`
  display: flex;
  flex-direction: column;
  margin-left: ${({ $screenSize }) =>
    $screenSize === 'mobile' ? '0px' : '100px'};
  text-align: left;
  margin-top: ${({ $screenSize }) => ($screenSize === 'mobile' ? '50px' : '0')};
`;

const Title = styled.div`
  font-size: 2rem;
  font-weight: 600;
`;

const Text = styled.div`
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.75;
  margin-bottom: 25px;
  margin-top: 25px;
  max-width: 600px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Credentials = styled.div<{ $screenSize: ScreenSize }>`
  display: flex;
  flex-direction: column;
  margin-left: ${({ $screenSize }) =>
    $screenSize === 'mobile' ? '20px' : '50px'};
`;

const Degree = styled.div`
  font-weight: 600;
  margin-bottom: 5px;
`;

const GradCert = styled.div`
  font-size: 0.8em;
`;

const AboutMe: FC = () => {
  const { screenSize } = useScreenSize();
  return (
    <Container $screenSize={screenSize}>
      <Title>About Me</Title>
      <Text>
        I’m a full-stack developer specializing in AI and data science, with
        core expertise in the MERN stack. I stay open to new technologies,
        particularly when it involves building AI models, analyzing data, and
        creating comprehensive reports. I also gain hands-on experience by
        experimenting with IoT, robotics, and game development to broaden my
        technical versatility.
      </Text>
      <Row>
        {/* Use the imported PDF file here */}
        <DownloadButton file={cv} />
        <Credentials $screenSize={screenSize}>
          <Degree>Master of Science in Computer Science</Degree>
          <GradCert>Graduate Certificate in Artificial Intelligence</GradCert>
          <GradCert>Graduate Certificate in Data Science</GradCert>
        </Credentials>
      </Row>
    </Container>
  );
};

export default AboutMe;
